import PartyPivotReport from "@/components/PartyPivotReport";

const PARTY_TYPES = [
  { value: "all", label: "All Suppliers" },
  { value: "creditor", label: "Sundry Creditors" },
  { value: "branch", label: "Branches" },
  { value: "related", label: "Related / Capital" },
  { value: "other", label: "Other" },
];

export default function PartyPurchase({ companyContext }) {
  return (
    <PartyPivotReport
      companyContext={companyContext}
      endpoint="party-purchase"
      title="Party-wise Purchase Report"
      subtitle="Monthly breakdown by supplier. Click any row to see item-wise detail. Download Excel for full breakdown."
      partyTypeOptions={PARTY_TYPES}
      totalColor="text-orange-700"
      testIdPrefix="party-purchase"
    />
  );
}
